import React from 'react';
import PropTypes from 'prop-types';

import './style.sass';

const TabWrapper = ({
  title, children, changeStatusTabStateHandler, statusTab, customTitle, visible,
}) => (
  visible
    ? (
      <div
        className={`tab-wrapper${statusTab ? ' tab-wrapper--open' : ''}`}
      >
        <div
          className="tab-wrapper__header"
          onClick={() => changeStatusTabStateHandler()}
          tabIndex="0"
          role="button"
          onKeyPress={() => changeStatusTabStateHandler()}
        >
          {title}
          <>
            {customTitle()}
          </>
          <button type="submit" title={`${statusTab ? 'Hide' : 'Show'} ${typeof title === 'string' ? title : 'Content'}`} className="tab-wrapper__toggle-button">
            <span className="icon-expand-arrow-dn" />
          </button>
        </div>
        <div className="tab-wrapper__body">
          {children}
        </div>
      </div>
    )
    : <></>
);

TabWrapper.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  customTitle: PropTypes.func,
  visible: PropTypes.bool,
  children: PropTypes.oneOfType(
    [PropTypes.element,
      PropTypes.string,
      PropTypes.array],
  ),
  changeStatusTabStateHandler: PropTypes.func.isRequired,
  statusTab: PropTypes.bool,
};

TabWrapper.defaultProps = {
  customTitle: () => {},
  visible: true,
  statusTab: false,
  children: <></>,
};

export default TabWrapper;
